import { render, staticRenderFns } from "./DeleAdmin.vue?vue&type=template&id=189e74ac&"
import script from "./DeleAdmin.vue?vue&type=script&lang=js&"
export * from "./DeleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DeleAdmin.vue?vue&type=style&index=0&id=189e74ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports